import React from "react";
import { Card, Typography } from "antd";
import styled from "styled-components";
import QuoteIcon from "assets/icons/quote.svg";

const { Text } = Typography;

const ReviewCardContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

const Testimonial = styled(Text)`
  display: block;
  font-weight: 500;
  font-size: 16px;
`;

const CustomerText = styled(Text)`
  color: #1070b6;
  display: block;
  font-weight: bold;
  font-size: 16px;
`;

const ReviewText = styled.div`
  flex: 1;
  margin-right: 10px;
`;

const QuoteImg = styled.img`
  width: 40px;
`;

type Review = {
  testimonial: string;
  customer: string;
  style?: React.CSSProperties;
};

const ReviewCard = ({ testimonial, customer, style }: Review) => {
  return (
    <Card size="small" style={style}>
      <ReviewCardContainer>
        <ReviewText>
          <Testimonial>{testimonial}</Testimonial>
          <CustomerText>{customer}</CustomerText>
        </ReviewText>
        <QuoteImg src={QuoteIcon} alt="quote icon" />
      </ReviewCardContainer>
    </Card>
  );
};

export default ReviewCard;
